import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";

export default function AppListItem({ to, icon, title, onClick, badge }) {
  if (to)
    return (
      <ListItem onClick={onClick} button style={{ padding: 0 }}>
        <NavLink
          to={to}
          className="navlink"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <div>
            {badge && (
              <div
                className="badge"
                style={{
                  width: "min-content",
                  padding: "0px 5px",
                  borderRadius: 10,
                  fontSize: 12,
                  position: "absolute",
                  right: 2,
                  top: 2,
                  zIndex: 2,
                }}
              >
                {badge}
              </div>
            )}
            {icon && (
              <ListItemIcon
                style={{ justifyContent: "center", alignItems: "center" }}
                className="nav-icon d-flex"
              >
                {icon}
              </ListItemIcon>
            )}
            <p className="nav-icon text-center" style={{ fontSize: 10 }}>
              {title}
            </p>
          </div>
        </NavLink>
      </ListItem>
    );

  return (
    <ListItem className="navlink" button={onClick === true} onClick={onClick}>
      {icon && <ListItemIcon className="nav-icon">{icon}</ListItemIcon>}
      <ListItemText className="nav-icon" primary={title} />
    </ListItem>
  );
}
